import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { HandCoins, X } from "lucide-react";
import { api, formatTL, extractErrorMessage } from "@/lib/api";

const STATUS = {
  bekliyor: ["Bekliyor", "bg-amber-100 text-amber-800"],
  onaylandi: ["Onaylandı", "bg-emerald-100 text-emerald-800"],
  reddedildi: ["Reddedildi", "bg-rose-100 text-rose-800"],
  iptal: ["Avans silindi", "bg-slate-200 text-slate-700"],
  isleniyor: ["İşleniyor", "bg-sky-100 text-sky-800"],
};

export const StatusPill = ({ s }) => {
  const [l, c] = STATUS[s] || [s, "bg-slate-100"];
  return <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${c}`}>{l}</span>;
};

const RequestModal = ({ onClose }) => {
  const [mine, setMine] = useState({ rows: [], linked: true });
  const [f, setF] = useState({ tutar: "", aciklama: "" });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/advance-requests/mine").then((r) => setMine(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/advance-requests", { tutar: Number(f.tutar), aciklama: f.aciklama });
      toast.success("Avans talebiniz yöneticiye iletildi");
      setF({ tutar: "", aciklama: "" });
      load();
    } catch (err) { toast.error(extractErrorMessage(err, "Talep gönderilemedi")); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm grid place-items-center p-4" data-testid="advance-request-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md max-h-[88vh] flex flex-col">
        <div className="p-4 border-b flex items-center justify-between">
          <h3 className="font-display font-bold flex items-center gap-2"><HandCoins size={16} /> Avans Talebi</h3>
          <button onClick={onClose} data-testid="advance-request-close" className="w-8 h-8 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={16} /></button>
        </div>
        <div className="p-4 overflow-y-auto space-y-4">
          {!mine.linked ? <div className="text-sm text-rose-700">Hesabınız bir personel kaydına bağlı değil. Yöneticinize başvurun.</div> : (
            <form onSubmit={submit} className="space-y-3">
              <label className="block text-xs font-semibold text-slate-600">Tutar (₺)
                <input required type="number" min="1" step="0.01" value={f.tutar} onChange={(e) => setF({ ...f, tutar: e.target.value })}
                  className="mt-1 w-full px-3 py-2 border border-slate-200 rounded-lg text-sm font-mono-tab" data-testid="advance-request-tutar" />
              </label>
              <label className="block text-xs font-semibold text-slate-600">Açıklama
                <textarea rows={3} maxLength={500} value={f.aciklama} onChange={(e) => setF({ ...f, aciklama: e.target.value })}
                  placeholder="Örn. kira, sağlık gideri..." className="mt-1 w-full px-3 py-2 border border-slate-200 rounded-lg text-sm" data-testid="advance-request-aciklama" />
              </label>
              <p className="text-[11px] text-slate-500">Taksit sayısını ve kesinti planını yönetici belirler.</p>
              <button type="submit" disabled={busy} data-testid="advance-request-submit"
                className="w-full py-2 rounded-lg bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold disabled:opacity-50">Talep Gönder</button>
            </form>
          )}
          {mine.rows.length > 0 && (
            <div data-testid="advance-request-mine">
              <div className="text-xs font-bold text-slate-700 mb-1">Taleplerim</div>
              <div className="space-y-1">
                {mine.rows.map((r) => (
                  <div key={r.id} className="text-xs border border-slate-200 rounded-md px-2 py-1.5 flex items-center gap-2" data-testid={`my-request-${r.id}`}>
                    <span className="font-mono-tab font-semibold">{formatTL(r.onaylanan_tutar ?? r.tutar)}</span>
                    <span className="text-slate-400">{new Date(r.created_at).toLocaleDateString("tr-TR")}</span>
                    <span className="flex-1 truncate text-slate-500">{r.red_nedeni || r.aciklama}</span>
                    <StatusPill s={r.status} />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const AdvanceRequestButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="advance-request-open"
        className="flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-3 py-2 rounded-lg font-semibold text-sm">
        <HandCoins size={15} /> Avans Talebi
      </button>
      {open && <RequestModal onClose={() => setOpen(false)} />}
    </>
  );
};
